var map = {
	"./0.png": 9084,
	"./1.png": 3342,
	"./2.png": 1983,
	"./3.png": 8447,
	"./4.png": 1897,
	"./5.png": 1188,
	"./6.png": 2184,
	"./7.png": 3268,
	"./8.png": 3857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4457;